import {Vue} from 'ui.vue';


import './BXmakerAuthuserphoneEnterAuth.styl';

import './BXmakerAuthuserphoneEnterSmsCode';
import './BXmakerAuthuserphoneEnterUserCall';
import './BXmakerAuthuserphoneEnterBotCall';
import './BXmakerAuthuserphoneEnterBotSpeech';
import './BXmakerAuthuserphoneEnterSimPush';
import './BXmakerAuthuserphoneEnterAuthForm';
import './BXmakerAuthuserphoneEnterAuthByPasswordForm';


Vue.component('BXmakerAuthuserphoneEnterAuth', {
    name: 'BXmakerAuthuserphoneEnterAuth',
    template: `
            <div class="bxmaker-authuserphone-enter-auth"  >
                                
                 <BXmakerAuthuserphoneHeader class="bxmaker-authuserphone-enter-auth__title" >
                    {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_AUTH_TITLE}}
                 </BXmakerAuthuserphoneHeader>    
                                              
                    <BXmakerAuthuserphoneEnterAuthForm 
                        v-show="!$root.isShowConfirm && !$root.isAuthByPassword" 
                    />  
                    
                    <BXmakerAuthuserphoneEnterAuthByPasswordForm 
                        v-show="!$root.isShowConfirm && $root.isAuthByPassword" 
                    />   
                                        
                    <BXmakerAuthuserphoneEnterSmsCode  
                        v-show="$root.isNeedShowConfirmSmsCode"                                    
                    /> 
                    
                    <BXmakerAuthuserphoneEnterUserCall  
                        v-show="$root.isNeedShowConfirmUserCall"   
                    /> 
                    
                    <BXmakerAuthuserphoneEnterBotCall 
                         v-show="$root.isNeedShowConfirmBotCall"                 
                    />  
                    
                    <BXmakerAuthuserphoneEnterBotSpeech 
                         v-show="$root.isNeedShowConfirmBotSpeech"                 
                    />  
                    
                    <BXmakerAuthuserphoneEnterSimPush 
                         v-show="$root.isNeedShowConfirmSimPush"                 
                    />  
                    
                    <div class="bxmaker-authuserphone-enter-auth__change-confirm" v-if="$root.isNeedShowChangeConfirm"  >
                         <BXmakerAuthuserphoneLink @onClick="$root.changeConfirmType" >
                            {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_CHANGE_CONFIRM_TYPE}}   
                         </BXmakerAuthuserphoneLink> 
                    </div>   
                    
                    
                    <div class="bxmaker-authuserphone-enter-auth__toregistration" v-if="!$root.isShowConfirm && $root.isEnabledRegister">
                         <BXmakerAuthuserphoneLink @onClick="$root.toRegistration" >
                                {{$root.localize.BXMAKER_AUTHUSERPHONE_ENTER_TO_REGISTRATION}}   
                        </BXmakerAuthuserphoneLink> 
                    </div>
                                                
            </div>
        `,
});